import tokens from 'airship-design-system/tokens.json'

export type Opacity = keyof typeof tokens.opacity

/* Transforms this:

  "opacity": {
    "10": {
      "value": 0.1,
      "type": "opacity"
    },
    "20": {
      "value": 0.2,
      "type": "opacity"
    },
    ...

  Into this:

    "10": 0.1,
    "20": 0.2,
    ...

*/

const opacities: Record<Opacity, number> = Object.keys(tokens.opacity).reduce(
  (obj, key) => {
    obj[key as Opacity] = tokens.opacity[key as Opacity].value
    return obj
  },
  {} as Record<Opacity, number>
)

export default opacities
